export const standardSearchFilter = (item, searchString) => {
  const target = replaceUmlauts(searchString.toLowerCase());
  const highlightStart = replaceUmlauts(item.label).toLowerCase().indexOf(target);
  if (highlightStart !== -1) {
    return {
      highlightStart,
      highlightEnd: highlightStart + target.length - 1
    };
  }
  return undefined;
};

/**
 * Repalce german umlauts because search strings like stadt should also match with städte
 * @param target
 */
function replaceUmlauts(target) {
  return target.replaceAll('ä', 'a').replaceAll('ö', 'o').replaceAll('ü', 'u').replaceAll('ß', 's');
}